import { emailZodSchema, type Email } from "@@/shared/email";
import { phoneZodSchema, type Phone } from "@@/shared/phone";
import { z } from "zod";

type PickUpDestination = {
    readonly _type: "PICK_UP_DESTINATION";
    readonly recipientId: string;
    readonly recipientName: string;
    readonly recipientType: "USER" | "PROVIDER";
    readonly contact: {
        readonly emails: Email[];
        readonly phones: Phone[];
    };
};

const pickUpDestinationZodSchema: z.ZodSchema<PickUpDestination> = z.object({
    _type: z.literal("PICK_UP_DESTINATION"),
    recipientId: z.string().min(1),
    recipientName: z.string().min(1),
    recipientType: z.enum(["USER", "PROVIDER"]),
    contact: z.object({
        emails: z.array(emailZodSchema),
        phones: z.array(phoneZodSchema),
    }),
});

export { pickUpDestinationZodSchema };
export type { PickUpDestination };
